module.exports = {"normal":"Normal","elite":"Élite","boss":"Boss","finalboss":"Dernier boss","rare":"Rare"};